import productDialogReducer from './productDialogReducer';

export default productDialogReducer;